import React from "react";
import "./nav.css";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { RiMenu4Fill } from "react-icons/ri";

const Nav = (act) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <div className="container saas-navbar">
        <nav>
          <div className="logo">
            <h4>SAASPHIRE</h4>
          </div>
          <div className="mobile-nav">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Tooltip title="Account settings">
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <RiMenu4Fill style={{ color: "white", fontSize: "30px" }} />
                </IconButton>
              </Tooltip>
            </Box>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  sx: {
                    background:
                      "linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.8) 100%)",
                    minWidth: "300px",
                    textAlign: "center",
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.8) 100%)",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem className="mobilemenuss">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `${isActive ? "activelink" : "nonactive"} mobilelinksss`
                  }
                >
                  Home
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    `${isActive ? "activelink" : "nonactive"} mobilelinksss`
                  }
                >
                  Who We Are
                </NavLink>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <NavLink
                  to="/what-we-do"
                  className={({ isActive }) =>
                    `${isActive ? "activelink" : "nonactive"} mobilelinksss`
                  }
                >
                  What We Do
                </NavLink>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    `${isActive ? "activelink" : "nonactive"} mobilelinksss`
                  }
                >
                  contact
                </NavLink>
              </MenuItem>
            </Menu>
          </div>
          <ul className="links saaslinks">
            <li>
              {" "}
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "activelink" : "nonactive"
                }
              >
                Home
              </NavLink>
            </li>
            <li>
              {" "}
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "activelink" : "nonactive"
                }
              >
                Who We Are
              </NavLink>
            </li>
            <li>
              {" "}
              <NavLink
                to="/what-we-do"
                className={({ isActive }) =>
                  isActive ? "activelink" : "nonactive"
                }
              >
                What We Do
              </NavLink>
            </li>
            <li>
              {" "}
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive ? "activelink" : "nonactive"
                }
              >
                Contact
              </NavLink>
            </li>

            {/* <NavLink
                to="/gallery"
                className={({ isActive }) =>
                  isActive ? "activelink" : "nonactive"
                }
              >
                Gallery
              </NavLink> */}
            {/* <NavLink
                to="/careers"
                className={({ isActive }) =>
                  isActive ? "activelink" : "nonactive"
                }
              >
                Careers
              </NavLink> */}
          </ul>
        </nav>
      </div>
    </>
  );
};
export default Nav;
